/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_DocumentsInputs */

const en_orders_documents = /** @type {(inputs: Orders_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

const es_orders_documents = /** @type {(inputs: Orders_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Orders_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_documents = /** @type {((inputs?: Orders_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_documents(inputs)
	return es_orders_documents(inputs)
});